import { render } from "./questionProfile.vue?vue&type=template&id=2cbf4eb1&ts=true"
import script from "./questionProfile.vue?vue&type=script&lang=ts"
export * from "./questionProfile.vue?vue&type=script&lang=ts"

import "./questionProfile.vue?vue&type=style&index=0&id=2cbf4eb1&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__